import { Component } from 'src/utils';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import template from './terms-conditions.html';

@Component({
  controllerAs: 'tnc',
  template
})

export default class Tnc {
  static $inject = [
    '$scope',
    '$state',
    '$ngRedux',
    '$location',
    
    
  
    '$stateParams',
    'authService',
    'APP',
    '$window'
  ];

  constructor($scope,$state,$ngRedux,  $location,  $stateParams, $auth, APP, $window) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    this.$state = $state;
    this.$location = $location;
    this.$window = $window;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.$auth = $auth;
    
    this.APP = APP;
    if (!$auth.isGuestLogin()) {
      $auth.getUserProfile()
          .then(success => $auth.getStoreDetail(success.data.store.storeURLName));
    }
    else {
      let guestStore = $auth.getGuestStoreDetail();
      $auth.getStoreDetail(guestStore.storeName);

    }
    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    return {
      profile: state.auth.profile
    };
  }

  isLoggedIn() {
    return this.$location.path().indexOf('auth') === -1 &&
      this.$state.current.name !== 'login' &&
      this.$state.current.name !== 'signup';
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  goToPrevState() {
    this.$window.history.back();
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/static/terms-conditions.js